const PDF_JS_VERSION = '4.10.38'
let pdfModule: Promise<any> | undefined

export async function loadPdfJs() {
  if (!pdfModule) {
    pdfModule = import(/* @vite-ignore */ `https://cdn.jsdelivr.net/npm/pdfjs-dist@${PDF_JS_VERSION}/build/pdf.mjs`).then(module => {
      module.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${PDF_JS_VERSION}/build/pdf.worker.mjs`
      return module
    })
  }
  return pdfModule
}

export type PdfExtractResult = {
  text: string
  pageCount: number
  pages: string[]
}

function normalizePageText(items: any[]) {
  const lines: string[] = []
  let current = ''
  let lastY: number | undefined
  for (const item of items) {
    const value = String(item.str || '').trim()
    if (!value) continue
    const y = Number(item.transform?.[5] || 0)
    if (lastY !== undefined && Math.abs(y - lastY) > 4 && current) {
      lines.push(current.trim())
      current = ''
    }
    current += `${current ? ' ' : ''}${value}`
    lastY = y
  }
  if (current) lines.push(current.trim())
  return lines.join('\n').replace(/([\u4e00-\u9fff])\s+([\u4e00-\u9fff])/g, '$1$2')
}

export async function extractPdfText(source: File | string, onProgress?: (page: number, total: number) => void): Promise<PdfExtractResult> {
  const pdfjs = await loadPdfJs()
  const data = source instanceof File ? new Uint8Array(await source.arrayBuffer()) : undefined
  const task = pdfjs.getDocument(data ? { data } : { url: source, withCredentials: false })
  const document = await task.promise
  const pages: string[] = []
  for (let pageNumber = 1; pageNumber <= document.numPages; pageNumber += 1) {
    const page = await document.getPage(pageNumber)
    const content = await page.getTextContent()
    pages.push(normalizePageText(content.items || []))
    onProgress?.(pageNumber, document.numPages)
    page.cleanup?.()
  }
  return {
    pageCount: document.numPages,
    pages,
    text: pages.map((page, index) => `第 ${index + 1} 页\n${page}`).join('\n\n')
  }
}

export async function openPdf(source: string) {
  const pdfjs = await loadPdfJs()
  return pdfjs.getDocument({ url: source, withCredentials: false }).promise
}